var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2674_3027)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2674_3027",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2674_3027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.667 6.79594H11.7403C10.1603 6.79594 8.87366 5.50927 8.87366 3.92927V2.0026C8.87366 1.63594 8.57366 1.33594 8.20699 1.33594H5.38033C3.32699 1.33594 1.66699 2.66927 1.66699 5.04927V10.9559C1.66699 13.3359 3.32699 14.6693 5.38033 14.6693H10.6203C12.6737 14.6693 14.3337 13.3359 14.3337 10.9559V7.4626C14.3337 7.09594 14.0337 6.79594 13.667 6.79594ZM8.18699 10.5226L6.85366 11.8559C6.80699 11.9026 6.74699 11.9426 6.68699 11.9626C6.62699 11.9893 6.56699 12.0026 6.50033 12.0026C6.43366 12.0026 6.37366 11.9893 6.31366 11.9626C6.26033 11.9426 6.20699 11.9026 6.16699 11.8626C6.16033 11.8559 6.15366 11.8559 6.15366 11.8493L4.82033 10.5159C4.62699 10.3226 4.62699 10.0026 4.82033 9.80927C5.01366 9.61594 5.33366 9.61594 5.52699 9.80927L6.00033 10.2959V7.5026C6.00033 7.22927 6.22699 7.0026 6.50033 7.0026C6.77366 7.0026 7.00033 7.22927 7.00033 7.5026V10.2959L7.48033 9.81594C7.67366 9.6226 7.99366 9.6226 8.18699 9.81594C8.38033 10.0093 8.38033 10.3293 8.18699 10.5226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6204 5.87365C12.2538 5.88032 13.1338 5.88032 13.8871 5.88032C14.2671 5.88032 14.4671 5.43365 14.2004 5.16699C13.2404 4.20032 11.5204 2.46032 10.5338 1.47365C10.2604 1.20032 9.78711 1.38699 9.78711 1.76699V4.09365C9.78711 5.06699 10.6138 5.87365 11.6204 5.87365Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2674_3027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c3c1a849b68b0cb114961cf4c25a6ee0.svg";
export { ForwardRef as ReactComponent };